import { FC } from 'react';
import { ResumenBase } from './ResumenBase';
import { SmilesForm } from './useSmiles';

type Props = {
  getClientData: () => SmilesForm | undefined;
};

export const SmilesResumen: FC<Props> = ({ getClientData }) => {
  const clientNumber = getClientData?.()?.clientNumber;

  if (clientNumber == null) return <></>;

  return (
    <ResumenBase ariaLabel={`Número Smiles Argentina: ${clientNumber}`}>
      N° Smiles Argentina: <b>{clientNumber}</b>
    </ResumenBase>
  );
};
